import React from "react";
import { useIcon } from "../../../assets/useIcon";
import "./SeemaError.scss";

interface SeemaErrorProps {
  className?: string;
}

const SeemaError: React.FC<SeemaErrorProps> = ({ className = "" }) => {
  const { getSvg } = useIcon();

  return (
    <div className={`seema-error-wrap ${className ? className : ""}`}>
      <div className="seema-bg" />
      <div
        className="seema-question-mark"
        style={{ backgroundImage: `url("${getSvg("questionmark")}")` }}
      />
      <div
        className="seema-question-mark"
        style={{ backgroundImage: `url("${getSvg("questionmark")}")` }}
      />
      <div
        className="seema-question-mark"
        style={{ backgroundImage: `url("${getSvg("questionmark")}")` }}
      />
      <div
        className="seema-face"
        style={{ backgroundImage: `url("${getSvg("girl")}")` }}
      />
      <div
        className="seema-hand"
        style={{ backgroundImage: `url("${getSvg("girl_hand")}")` }}
      />
    </div>
  );
};

export default SeemaError;
